import { EmptyState } from '@/components/ui/empty-state';
import { ENROLLMENT_STATUS } from '@/types/enrollment-status';
import { Enrollments } from '@/types/enrollments';
import { router } from 'expo-router';
import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Button } from '../ui/button';
import { StaticList } from '../ui/static-list';
import { EnrollmentCard } from './enrollment-card';

type ServiceEnrollmentsTabProps = {
  enrollments: Enrollments[] | undefined | null;
  serviceId: string | undefined;
};

/** Quem pede ação primeiro, quem já morreu por último. */
const statusOrder: { [key in ENROLLMENT_STATUS]: number } = {
  [ENROLLMENT_STATUS.PENDING_APPROVAL]: 1,
  [ENROLLMENT_STATUS.ACTIVE]: 2,
  [ENROLLMENT_STATUS.PAUSED]: 3,
  [ENROLLMENT_STATUS.COMPLETED]: 4,
  [ENROLLMENT_STATUS.INACTIVE]: 5,
  [ENROLLMENT_STATUS.CANCELLED]: 6,
};

export function ServiceEnrollmentsTab({ enrollments, serviceId }: ServiceEnrollmentsTabProps) {
  const handleNewEnrollment = () => {
    if (!serviceId) return;
    router.push(`/(tabs)/(provider)/enrollments/new?serviceId=${serviceId}`);
  };

  const sortedEnrollments = useMemo(() => {
    if (!enrollments) return [];

    return [...enrollments].sort((a, b) => {
      const orderA = statusOrder[a.status] ?? 99;
      const orderB = statusOrder[b.status] ?? 99;
      return orderA - orderB;
    });
  }, [enrollments]);
  return (
    <View className="w-full flex-1 gap-5 px-5 pt-5">
      <Button title="+ Novo Contrato" onPress={handleNewEnrollment} disabled={!serviceId}></Button>

      {sortedEnrollments.length === 0 ? (
        <EmptyState
          icon="document-text-outline"
          title="Nenhum contrato neste serviço"
          description="Crie um contrato para começar a cobrar por este serviço."
          actionLabel="Novo contrato"
          onAction={handleNewEnrollment}
        />
      ) : (
        <StaticList
          data={sortedEnrollments}
          keyExtractor={(item) => item.id}
          renderItem={(item) => <EnrollmentCard enrollment={item} />}
        />
      )}
    </View>
  );
}
